module.exports = __webpack_public_path__ + "img/cron-transaction.4f9aaff1.svg";